<template >
	<span v-if="errored" >[ERROR]</span>
	<span v-else-if="loading"  class="loading_string" >&nbsp;</span>
	<span v-else >{{ display_string }}</span>
</template>


<script>

	import { ref } from "vue";

	export default {
		props : [
            'value',
			'value_loading',

			'data_url',
			'render',
		],				
		
		setup(props) {
			return {
				rendered_text : ref(''),
				errored : ref(false),
				loading : ref(props.value_loading),
            };
		},

		beforeMount(){
			if(this.data_url){
				this.getData();
			}
		},

		watch:{
			data(){
				this.items = this.data;
			},
			value_loading(){
				this.loading = this.value_loading;
			},
		},
		
		computed:{
			display_string(){
				if(this.data_url){
                    return this.rendered_text;
                }
                return this.value
			},

		},
		methods: {

			defaultRender(data){
				return data.data.name;
			},
			
			getData( append ){
				var self = this;
				self.loading = true;
				self.errored = false;

				return axios.get(this.data_url).then(({data})=>{
					this.rendered_text = (this.render)?this.render(data):this.defaultRender(data);
				}).catch((e)=>{
					self.errored = true;
					console.error(e)
				}).finally(()=>{
					self.loading = false;
				})
				
			},

		}
	}
</script>